<script setup>
const route = useRoute()
const mapName = route.params.area
if (!areaToPrefTable.find(({ key }) => key === mapName)) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid areaId'
  })
}
useCustomMeta('area', getPrefectureName(mapName))
const breadCrumbList = getBreadCrumb(mapName)
</script>

<template>
  <div>
    <NuxtLayout
      name="area"
      :bread-crumb-list="breadCrumbList"
    >
      <div class="frame">
        <GolfMap
          :map-name="mapName"
          :map-data="areaToPrefTable.find(({ key }) => key === mapName).pref_list"
        />
      </div>
      <template #main-center>
        <GolfSearch />
        <GolfLog />
      </template>
      <template #main-bottom>
        <GolfRecommend :area="mapName" />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
</style>
